<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
	<div class="modal-dialog modal-lg modal-dialog-centered" (click)="$event.stopPropagation()">
		<div class="modal-content shadow-lg border-0">
			<div class="modal-header bg-light">
				<h5 class="modal-title d-flex align-items-center">
					<i class="bi bi-card-list me-2"></i> Selecionar Orçamento
				</h5>
				<button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
			</div>

			<div class="modal-body">
				<div class="input-group mb-4 shadow-sm">
					<span class="input-group-text bg-white border-end-0">
						<i class="bi bi-search text-muted"></i>
					</span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Pesquise por ID, nome do cliente ou valor..."
						[(ngModel)]="searchTerm"
						(keyup.enter)="search()"
					>
					<button class="btn btn-primary px-4" type="button" (click)="search()">Pesquisar</button>
					<button class="btn btn-outline-secondary" type="button" (click)="clearSearch()">Limpar</button>
				</div>

				<div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
					<table class="table table-hover align-middle">
						<thead class="table-light sticky-top">
							<tr>
								<th class="text-center" style="width: 50px;">#</th>
								<th style="width: 80px;">ID</th>
								<th>Cliente</th>
								<th class="text-center" style="width: 140px;">Valor</th>
								<th class="text-center" style="width: 140px;">Data</th>
								<th class="text-center" style="width: 120px;">Válido até</th>
							</tr>
						</thead>
						<tbody>
							<tr
								*ngFor="let orcamento of paginatedOrcamentos"
								(click)="selectOrcamento(orcamento)"
								[class.table-primary]="selectedOrcamento?.id === orcamento.id"
								style="cursor: pointer;"
							>
								<td class="text-center">
									<div class="form-check d-flex justify-content-center">
										<input class="form-check-input" type="radio" name="orcamento" [checked]="selectedOrcamento?.id === orcamento.id">
									</div>
								</td>
								<td>{{ orcamento.id }}</td>
								<td>
									<div class="fw-bold text-dark">{{ orcamento.nomeCliente }}</div>
								</td>
								<td class="text-center">{{ orcamento.valorTotal | currency:'BRL' }}</td>
								<td class="text-center">{{ orcamento.dataOrcamento | date:'dd/MM/yyyy' }}</td>
								<td class="text-center">{{ orcamento.validadeOrcamento | date:'dd/MM/yyyy' }}</td>
							</tr>

							<tr *ngIf="paginatedOrcamentos.length === 0">
								<td colspan="6" class="text-center py-5">
									<i class="bi bi-journal-x fs-2 text-muted d-block mb-2"></i>
									<span class="text-muted">Nenhum orçamento encontrado.</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="d-flex justify-content-between align-items-center mt-3" *ngIf="pages.length > 0 && totalPages > 1">
					<small class="text-muted">Mostrando página {{ currentPage + 1 }} de {{ totalPages }}</small>
					<nav>
						<ul class="pagination pagination-sm mb-0">
							<li class="page-item" [class.disabled]="currentPage === 0">
								<button class="page-link" type="button" (click)="setPage(0)">Primeira</button>
							</li>
							<li class="page-item" [class.disabled]="currentPage === 0">
								<button class="page-link" type="button" (click)="setPage(currentPage - 1)">Anterior</button>
							</li>
							<li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
								<button class="page-link" type="button" (click)="setPage(page)">{{ page + 1 }}</button>
							</li>
							<li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
								<button class="page-link" type="button" (click)="setPage(currentPage + 1)">Próxima</button>
							</li>
							<li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
								<button class="page-link" type="button" (click)="setPage(totalPages - 1)">Última</button>
							</li>
						</ul>
					</nav>
				</div>
			</div>

			<div class="modal-footer bg-light">
				<button type="button" class="btn btn-outline-secondary" (click)="onClose()">Cancelar</button>
				<button class="btn btn-success px-5" type="button" [disabled]="!selectedOrcamento" (click)="inserirOrcamento()">
					<i class="bi bi-check-lg me-2"></i> Confirmar Seleção
				</button>
			</div>
		</div>
	</div>
</div>
